<div class="mb-3">
  <button class="btn btn-outline-danger" (click)="deleteObsoleteMrRelated()">
    <i class="bi bi-trash" aria-hidden="true"></i> delete obsolete MR related
  </button>
</div>

<table class="table table-hover table-sm">
  <thead class="thead-light">
    <tr>
      <th scope="col">ID</th>
      <th scope="col">UID</th>
      <th scope="col">Created</th>
      <th scope="col">Responded</th>
      <th scope="col">GitLab MR</th>
      <th scope="col">Status</th>
      <th scope="col">Actions</th>
    </tr>
  </thead>
  <tbody>
    @for (cmd of commands; track cmd.id) {
      <tr (click)="toggleExpand(cmd.id)" class="cursor-pointer">
        <td>{{ cmd.id }}</td>
        <td>{{ cmd.stracliCommandUid }}</td>
        <td>{{ cmd.created | date:'yyyy-MM-dd HH:mm:ss' }}</td>
        <td>{{ cmd.responseReceived ? (cmd.responseReceived | date:'yyyy-MM-dd HH:mm:ss') : 'Pending' }}</td>
        <td>
          @if (cmd.gitlabMrActionType) {
            <span class="badge bg-info text-dark">{{ cmd.gitlabMrActionType }}</span>
          }
          @if (cmd.gitlabMrWebUrl) {
            <a [href]="cmd.gitlabMrWebUrl" target="_blank" class="ms-1" (click)="$event.stopPropagation()">
              <i class="bi bi-box-arrow-up-right" aria-hidden="true"></i> {{ cmd.gitlabMrWebUrl }}
            </a>
          }
          @if (cmd.gitlabMrGitlabStatus) {
            <span class="badge ms-1" [ngClass]="getGitlabStatusClass(cmd.gitlabMrGitlabStatus)">GitLab: {{ cmd.gitlabMrGitlabStatus }}</span>
          }
          @if (cmd.gitlabMrStrapiStatus) {
            <span class="badge ms-1" [ngClass]="getStrapiStatusClass(cmd.gitlabMrStrapiStatus)">Strapi: {{ cmd.gitlabMrStrapiStatus }}</span>
          }
        </td>
        <td>
          @if (cmd.response) {
            <span class="badge" [ngClass]="cmd.response.exitCode === 0 ? 'bg-success' : 'bg-danger'">
              Exit: {{ cmd.response.exitCode }}
            </span>
          } @else {
            <span class="badge bg-warning text-dark">Waiting</span>
          }
        </td>
        <td>
          <button class="btn btn-sm btn-outline-danger" (click)="deleteCommand(cmd.id, $event)">Delete</button>
        </td>
      </tr>
      @if (expandedId === cmd.id) {
        <tr>
          <td colspan="7" class="bg-light">
            <div class="p-3">
              @if (cmd.command) {
                <div>
                  <strong>Command (stdin):</strong>
                  <pre class="mt-1">{{ cmd.command.stdin }}</pre>
                </div>
              }
              @if (cmd.response) {
                <div class="mt-3">
                  <strong>Response:</strong>
                  <div class="row mt-2">
                    <div class="col-md-6">
                      <h6>stdout:</h6>
                      <pre class="small">{{ cmd.response.stdout || '(empty)' }}</pre>
                    </div>
                    <div class="col-md-6">
                      <h6>stderr:</h6>
                      <pre class="small text-danger">{{ cmd.response.stderr || '(empty)' }}</pre>
                    </div>
                  </div>
                  <div class="mt-2">
                    <small>Terminated on its own: {{ cmd.response.terminatedOnItsOwn }}</small>
                  </div>
                </div>
              } @else {
                <div class="text-muted">
                  No response received yet.
                </div>
              }
            </div>
          </td>
        </tr>
      }
    }
  </tbody>
</table>
